import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerPurchasesCompleteSellerMessagingButtonClickedEvent = (
	numberOfAvailableSellersToContact: string,
): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.complete,
		customData: { label: `${numberOfAvailableSellersToContact}` },
		name: 'dlr_purchases_complete_seller_messaging_button_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
